import { useQuery } from '@tanstack/react-query'
import { fetchBudget } from '../../../api/budgets/budgets'
import { BudgetItem } from '../../../entities/Budget'

interface UseBudgetItemOptions {
  objectId: string
  costItemStickerIds: string[]
}

export const useBudget = ({
  objectId,
  costItemStickerIds = []
}: UseBudgetItemOptions) =>
  useQuery<BudgetItem>({
    queryKey: ['budget', objectId, costItemStickerIds],
    queryFn: () =>
      fetchBudget(objectId, {
        costItemStickerIds: costItemStickerIds
      }),
    enabled: !!objectId && !!costItemStickerIds.length,
    staleTime: 5 * 60 * 1000
  })
